// Copyright (c) 2020 Deere & Company

import RecalledPartTab from './recalled-part-tab';
import RgaMassUpdate from './rga-mass-update-routes';
import RgaMassUpload from './rga-mass-upload';
import RgaResults from './rga-results';
import RgaSearch from './search';
import reports from './reports';

export default {
    childRoutes: [
        RecalledPartTab,
        RgaMassUpdate,
        RgaMassUpload,
        RgaResults,
        RgaSearch,
        reports
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/rga/search')
    },
    name: 'Part Request Analysis',
    path: 'rga'
};



// WEBPACK FOOTER //
// ./src/routes/rga/index.js